import { render, staticRenderFns } from "./edit-job.vue?vue&type=template&id=2da52aac&"
import script from "./edit-job.vue?vue&type=script&lang=js&"
export * from "./edit-job.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports